var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1187 12.78C12.0487 12.77 11.9587 12.77 11.8787 12.78C10.1187 12.72 8.71875 11.28 8.71875 9.50998C8.71875 7.69998 10.1787 6.22998 11.9987 6.22998C13.8087 6.22998 15.2787 7.69998 15.2787 9.50998C15.2687 11.28 13.8787 12.72 12.1187 12.78Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7417 19.3801C16.9617 21.0101 14.6017 22.0001 12.0017 22.0001C9.40172 22.0001 7.04172 21.0101 5.26172 19.3801C5.36172 18.4401 5.96172 17.5201 7.03172 16.8001C9.77172 14.9801 14.2517 14.9801 16.9717 16.8001C18.0417 17.5201 18.6417 18.4401 18.7417 19.3801Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalPic);
export default __webpack_public_path__ + "static/media/personal_pic.859f34bb7b8153f015f87d4bcd332791.svg";
export { ForwardRef as ReactComponent };